module.exports = __webpack_public_path__ + "static/media/image17.8748ab81.jpg";